import styled from 'styled-components';

const GroupWrapper = styled.div`
  display: flex;
  overflow-x: auto;
`;

export {GroupWrapper};
